import '../cart.js';
import '../form.js';
import { Slider } from "../elements/slider";
import 'swiper/css/bundle';
import useBreakpoints from '../functions/useBreakpoints';

const {breakpoints: tailwindBreakpoints} = useBreakpoints();

window.appLoaded.then(() => {
    $(document).ready(function () {
    hideThumbs(true);

        // Product with optionseries
        if (intProductPricetypeno == 2) {
            // Select another option
            $('select[name*="OptionSerie"]').change(function () {
                if ($(this).find(':selected').data('href')) {
                    // Go to the url from the option
                    document.location = $(this).find(':selected').data('href');
                }
            });
        }

        // Add to cart
        AddToCart($('form#frmAddToCart button#btnAddToCart'), WebsiteSettingBlnShowAddToCartQtyField, true);

        // Mail on stock
        if (WebsiteSettingBlnMailOnStock) {
            // Clicking on button from mail on stock => ajax form
            $('input#btnMailStock').click(function () {
                var objInput = $('input#txtEmailStock');
                var objInputParent = objInput.parent();


                // Check if there's a correct e-mail entered => then add request to database
                $.post(strAjaxPath + 'mail-on-stock.php', 'intArticleNo=' + $('input#hdnArticleNo').val() + '&intPriceNo=' + $('input#hdnPriceNo').val() + '&strEmailStock=' + $('input#txtEmailStock').val(), function (data) {

                    $('label[for="txtEmailStock"]').remove();
                    objInput.removeClass('is-invalid');

                    if (data.value == 0) {
                        // Error
                        objInput.addClass('is-invalid');
                        objInputParent.append('<label class="invalid-feedback" for="txtEmailStock">' + data.message + '</label>');
                    } else {
                        // Notitication
                        objInputParent.parent().hide();
                        objInputParent.parent().parent().append('<div class="alert alert-success">' + data.message + '</div>');
                    }
                }, 'json');
            });
        }

        // Check if there are linked products with an add-to-cart button
        if (intSizeRelatedProducts > 0) {
            AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
        }

        //ADD TO WISHLIST
        $('#add-to-wishlist').click(function () {
        var $button = $(this);
            var strWishlistArticles = GetLocalStorage('strWishlistArticles');

            var strParams = 'intArticleno=' + $(this).data('article');
            strParams += '&strType=add';
            strParams += '&strWishlistArticles=' + strWishlistArticles;

            $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
                if (objResponse != '') {
                // update button icon
                $button.find('i').removeClass('fa-regular').addClass('fa-solid');

                    // Save session storage
                    SetLocalStorage('strWishlistArticles', objResponse.articles);

                    $.post(strAjaxPath + 'wishlist/wishlist-popup.php', strParams, function (data) {
                        $.fancybox.open(
                            data,
                            {
                                afterLoad: function () {
                                    // Move product to another another list
                                    $('input[type=radio][name="wishlist"]').click(function () {
                                        var strValue = $(this).val();
                                        var strParams = 'intArticleno=' + $('#hdnArticle').val();
                                        strParams += '&strGiftlistno=' + strValue;
                                        var objInput = $(this);
                                        // Icons
                                        $('input[type=radio][name="wishlist"] + label').find('.fa-spin').addClass('hidden');
                                        objInput.next().find('.fa-spin').removeClass('hidden');

                                        setTimeout(function () {
                                            objInput.next().find('.fa-spin').addClass('hidden');
                                            objInput.next().find('.fa-check').removeClass('hidden');
                                        }, 1000);

                                        setTimeout(function () {
                                            objInput.next().find('.fa-check').addClass('hidden');
                                        }, 2000);

                                        // Update wish list
                                        $.post(strAjaxPath + 'wishlist/wishlist-update-list.php', strParams, function (data) {
                                            if (data == 'OK') {
                                                $('a#parent').attr('href', strPath + strLang + '/wishlist/' + strValue);
                                            }
                                        });
                                    });


                                    $('#new-list').click(function () {
                                        $('#frmWishlist').removeClass('hidden');
                                        $('#frmWishlist').addClass('flex');
                                        return false;
                                    });

                                    // Validate form to add new wishlist
                                    FormValidateAddWishlist($('form#frmWishlist'));
                                },
                            },
                        );
                    });
                }
            }, 'json');
            return false;
        });

    // Main media-slider functionality for product-detail
    const productMediaSliders = document.querySelectorAll('[data-slider="product-media"]');
    if (productMediaSliders?.length > 0) {
        const objSlider = Slider();
        productMediaSliders.forEach(mediaSlider => {
            const strTarget = mediaSlider.getAttribute('data-target-thumbs');
            const mediaThumbSlider = document.querySelector(`.${strTarget}`);
            objSlider.init({
                mainSliderSelector: mediaSlider,
                thumbsSliderSelector: mediaThumbSlider,
            });
        });
    }

    function getMaxAllowed(thumbs) {
        let maxAllowed = 4;

        if ([parseInt(tailwindBreakpoints.xl)]) {
            maxAllowed = 5;
        } else if ([parseInt(tailwindBreakpoints.md)]) {
            maxAllowed = 3;
        }

        return maxAllowed;
    };

    function hideThumbs(init = false) {
        const thumbs = $('.thumb');
        const maxAllowed = getMaxAllowed(thumbs);
        const rest = thumbs.length - maxAllowed;

        if (rest > 0) {
            thumbs.attr('data-images-count', `+ ${rest}`);
        } else {
            thumbs.removeAttr('data-images-count');
        }

        thumbs.each(function (index) {
            if ((index + 1) > maxAllowed) {
                $(this).addClass('!hidden');
            } else {
                $(this).removeClass('!hidden');
            }
        });

        // set last class on last the max allowed thumb
        thumbs.removeClass('show-more');
        $(`.gallery-thumbs .thumb:nth-child(${maxAllowed})`).addClass('show-more');

        if (init) {
            thumbs.each(function (index) {
                $(this).on('click', () => {
                    const maxAllowed = getMaxAllowed(thumbs);
                    const rest = thumbs.length - maxAllowed;

                    if ((index + 1) !== maxAllowed || rest <= 0) {
                        return true;
                    }
                    $(`[data-slider="product-media"] .swiper-slide:nth-child(${maxAllowed}) > [data-fancybox="gallery"]`).trigger('click');
                });
            });
        }
    }

    // ============================================================================
    // Venue Rental Widget Initialization
    // ============================================================================
    let bookingWidgetInitialized = false;

    // Function to scroll to widget section and initialize widget
    async function scrollAndInitBookingWidget() {
        const widgetSection = document.getElementById('booking-widget-section');
        const widgetContainer = document.getElementById('pdp-booking-widget');

        if (!widgetSection || !widgetContainer) {
            console.warn('Venue rental widget section or container not found');
            return;
        }

        // Scroll to widget section with smooth behavior
        widgetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Initialize widget if not already initialized
        if (!bookingWidgetInitialized && window.BookingWidget) {
            // Hide button immediately on click for better UX
            $('.booking-init-btn').hide();

            try {
                await window.BookingWidget.initializeContainer(widgetContainer);
                bookingWidgetInitialized = true;

                console.log('Venue rental widget initialized successfully');
            } catch (error) {
                console.error('Failed to initialize venue rental widget:', error);
            }
        }
    }

    // Handle click on button in bookable-info (sidebar) - scroll to widget and initialize
    $('.booking-open-btn').on('click', function(e) {
        e.preventDefault();
        scrollAndInitBookingWidget();
    });

    // Handle click on button in venue-rental section itself - just initialize widget
    $('.booking-init-btn').on('click', async function(e) {
        e.preventDefault();
        const widgetContainer = document.getElementById('pdp-booking-widget');
        const $button = $(this);

        if (!bookingWidgetInitialized && widgetContainer && window.BookingWidget) {
            // Hide button immediately on click for better UX
            $button.hide();

            try {
                await window.BookingWidget.initializeContainer(widgetContainer);
                bookingWidgetInitialized = true;

                console.log('Venue rental widget initialized successfully');
            } catch (error) {
                console.error('Failed to initialize venue rental widget:', error);
            }
        }
    });

    });
});
